import { CommissionsBatchStep } from "../batch/enums";
import { CommissionAdvanceCancellationReason, CommissionAdvanceStatus } from "./enums";
import { CommissionAdvance } from "./types";

// The other reasons are set only by the monthly evaluation of the advance
export const MANUAL_COMMISSION_ADVANCE_CANCELLATION_REASONS = [
  CommissionAdvanceCancellationReason.CONTRACT_TERMINATED,
  CommissionAdvanceCancellationReason.AGENT_COOPERATION_ENDED,
  CommissionAdvanceCancellationReason.CONTRACT_PARAMETERS_CHANGED,
  CommissionAdvanceCancellationReason.CONTRACT_GAINERS_CHANGED,
];

export const isCommissionAdvanceRunning = (advance: CommissionAdvance) =>
  advance.status === CommissionAdvanceStatus.ACTIVE || advance.status === CommissionAdvanceStatus.OVERDUE;

// The API rejects any change while a batch working with the advance is not finished yet
export const isCommissionAdvanceInUnfinishedBatch = (advance: CommissionAdvance) =>
  [
    advance.payoutCommission?.batch,
    ...advance.cycles.map((cycle) => cycle.batch),
    ...advance.inputs.map((input) => input.batch),
  ].some((batch) => batch && batch.step !== CommissionsBatchStep.FINISH);
